import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchMenusIfNeeded, fetchNewsIfNeeded, selectAZ } from "../../actions";
import { NewsItem } from "../NewsView/NewsItem";
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { FooterNote } from "../FooterLinks/FooterNote";
import { SearchView } from "../SearchView/SearchView";

export class NewsGalleryView extends React.Component {
  constructor(props) {
    super(props);
    this.toggleAZorder = this.toggleAZorder.bind(this);
    this.gotoPage = this.gotoPage.bind(this);

    this.state = {
      selectedAZ: 0
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchNewsIfNeeded(this.props.selectedScope));
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, selectedScope } = nextProps;
    if (nextProps.selectedScope !== this.props.selectedScope) {
      dispatch(fetchNewsIfNeeded(selectedScope));
      dispatch(fetchMenusIfNeeded(selectedScope));
    }
  }

  toggleAZorder(e) {
    e.preventDefault();
    e.stopPropagation();
    const orderByNameState = e.target.classList.contains("active-gallery")
      ? 0
      : 1;
    this.props.dispatch(selectAZ(orderByNameState));
  }

  renderNews() {
    const { news, isFetchingNews } = this.props;

    if (isFetchingNews && news.length === 0) {
      const loadmessage = isFetchingNews
        ? "A carregar conteúdos..."
        : "Não existem notícias";
      return <h4 style={{ color: "#ccc" }}>{loadmessage}</h4>;
    }

    if (!isFetchingNews && news.length === 0) {
      return <h4 style={{ color: "#ccc" }}>Não existem notícias."</h4>;
    }

    if (this.props.selectedAZ === 1) {
      const orderedActivities = news.sort(this.compare);
      return orderedActivities.map((news_item, i) => {
        return <NewsItem grid_size={4} news={news_item} key={i} />;
      });
    } else {
      const orderedActivities = news.sort(this.compareByDate);
      return orderedActivities.map((news_item, i) => {
        return <NewsItem grid_size={4} news={news_item} key={i} />;
      });
    }
  }

  compare(a, b) {
    if (a.title < b.title) {
      return -1;
    } else if (a.title > b.title) {
      return 1;
    } else {
      return 0;
    }
  }

  compareByDate(a, b) {
    a = new Date(a.published_at);
    b = new Date(b.published_at);
    return a > b ? -1 : a < b ? 1 : 0;
  }

  gotoPage(page) {
    this.props.history.push("/pesquisa");
  }

  render() {
    const { menus, selectedAZ, isFetchingNews, dispatch } = this.props;
    // const num_movies = Object.keys(movies).length
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];
    const orderByNameClass = selectedAZ === 1 ? "active-gallery" : "";

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="movies-view" className="row m-gallery">
          <SearchView
            gotoPage={this.gotoPage}
            dispatch={dispatch}
            customStyle={"alignleft"}
          />
          <div className="col-md-12">
            <p className="section-title">NOTÍCIAS</p>
          </div>
          <div className="grid-header">
            <p>Ordenar por</p>
            <div>
              <button onClick={this.toggleAZorder} className={orderByNameClass}>
                NOTÍCIAS A a Z
              </button>
            </div>
          </div>
          <div className="feedback">
            <div
              id="movie-list"
              className="col-xs-12 no-pad"
              style={{ opacity: isFetchingNews ? 0.5 : 1 }}
            >
              {this.renderNews()}
            </div>
          </div>
        </div>
        <FooterLinks bottom_menus={bottom_menus} />
        <FooterNote />
      </div>
    );
  }
}

NewsGalleryView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  news: PropTypes.array.isRequired,
  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  isFetchingNews: PropTypes.bool.isRequired,
  selectedAZ: PropTypes.number.isRequired,
  selectedScope: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const { getAllnews, getMenus, selectedAZ, selectedScope } = state;
  const { isFetchingNews, items: news } = getAllnews["all"] || {
    isFetchingNews: true,
    items: []
  };

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  return {
    news,
    isFetchingNews,
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    selectedAZ,
    selectedScope
  };
}

export default connect(mapStateToProps)(NewsGalleryView);



// WEBPACK FOOTER //
// ./src/views/NewsView/NewsGalleryView.js